import { createStyles } from '@mantine/styles';


export default createStyles((theme: { colors: { [x: string]: any[] }; colorScheme: string; shadows: any }) => ({

    paper: {
        margin: '0 auto',
        textAlign: 'justify',
        fontSize: 12,
        maxWidth: 500,
        padding: 20,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[3],
        boxShadow: theme.shadows.sm,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
    },

    h1: {
        textAlign: 'center',
        letterSpacing: 0.6,
    },

    h2: {
        textAlign: 'center',
        letterSpacing: 0.6,
        color: theme.colors.orange[5],
    },

    staticListMain: {
        fontSize: 12,
        lineHeight: 1.8,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[8],
        'li': {
            borderBottom: 1,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            borderStyle: 'dashed',
            borderColor: theme.colors.gray[6],
        },

        'li:last-child': {
            borderBottom: 0,
        },

        /*'.mantine-List-itemWrapper': {
            whiteSpace: 'break-spaces',
        },*/
    },

    staticListNested: {
        fontSize: 12,
        lineHeight: 1.8,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[3] : theme.colors.gray[7],
        'li': {
            borderBottom: 1,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            borderStyle: 'dashed',
            borderColor: theme.colors.orange[3],
        },

        'li:last-child': {
            borderBottom: 0,
        },

        /*'.mantine-List-itemWrapper': {
            whiteSpace: 'break-spaces',
        },*/
    },

}));
